import React from "react";

function formatNumber(val, precision) {
  return val.toFixed(precision);
}

function CustomLabel({
  x,
  y,
  width,
  height,
  value,
  prefix,
  suffix,
  precision,
  layout = "horizontal",
  xOffset = 30,
  hideZero = false,
  showIntegerLabel = false
}) {
  const xxOffset =
    layout === "horizontal"
      ? x + width / 2
      : value < 0
        ? x + width - xOffset
        : x + width + xOffset;
  const yOffset =
    layout === "vertical" ? y + height / 2 : value < 0 ? y + 10 : y - 10;
  const className = value < 0 ? "red" : null;
  const val =
    hideZero === true && value === 0
      ? "n/a"
      : showIntegerLabel
        ? Math.round(value)
        : `${prefix}${formatNumber(value, precision)}${suffix}`;

  return (
    <text
      x={xxOffset}
      y={yOffset}
      className={className}
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {val}
    </text>
  );
}

export default CustomLabel;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/custom-label.js